import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { SmsLimitModel, SmsRuleModel, SmsStatsModel } from 'Pages/som'
import { Id } from 'Types/aliases'

export type SmsSettingsState = {
	data: ResponseCatalog<SmsRuleModel>
	requestParams: RequestParams
	stats?: SmsStatsModel
	limit?: SmsLimitModel
	formState: {
		open: boolean
		item?: SmsRuleModel
	}
}

export const smsSettingsInitialState: SmsSettingsState = {
	data: new ResponseCatalog<SmsRuleModel>(),
	requestParams: new RequestParams(),
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace SmsSettingsNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		searchMissing?: boolean
	}>
	export type SetAll = PayloadAction<ResponseCatalog<SmsRuleModel>>
	export type SetParams = PayloadAction<RequestParams>

	export type CreateOne = PayloadAction<SmsRuleModel>
	export type UpdateOne = PayloadAction<{
		id: Id
		data?: SmsRuleModel
	}>
	export type DeleteOne = PayloadAction<Id>

	export type GetSmsStats = PayloadAction
	export type SetSmsStats = PayloadAction<SmsStatsModel>

	export type GetSmsLimit = PayloadAction
	export type SetSmsLimit = PayloadAction<SmsLimitModel>
	export type UpdateSmsLimit = PayloadAction<{
		data?: SmsLimitModel
		callback?: Callback
	}>
	export type OpenForm = PayloadAction<{ item?: SmsRuleModel }>
	export type CloseForm = PayloadAction
}

export const smsSettingsSlice = createSlice({
	name: 'smsSettings',
	initialState: smsSettingsInitialState,
	reducers: {
		getAll: (state, action: SmsSettingsNS.GetAll) => {},
		setAll: (state, action: SmsSettingsNS.SetAll) => {
			state.data = action.payload
		},
		setParams: (state, action: SmsSettingsNS.SetParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.data = new ResponseCatalog<SmsRuleModel>()
			state.requestParams = new RequestParams()
		},
		updateOne: (state, action: SmsSettingsNS.UpdateOne) => {},
		createOne: (state, action: SmsSettingsNS.CreateOne) => {},
		deleteOne: (state, action: SmsSettingsNS.DeleteOne) => {},

		getSmsStats: (state, action: SmsSettingsNS.GetSmsStats) => {},
		setSmsStats: (state, action: SmsSettingsNS.SetSmsStats) => {
			state.stats = action.payload
		},

		getSmsLimit: (state, action: SmsSettingsNS.GetSmsLimit) => {},
		setSmsLimit: (state, action: SmsSettingsNS.SetSmsLimit) => {
			state.limit = action.payload
		},
		updateSmsLimit: (state, action: SmsSettingsNS.UpdateSmsLimit) => {},
		openForm: (state, action: SmsSettingsNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state, action: SmsSettingsNS.CloseForm) => {
			state.formState = smsSettingsInitialState.formState
		},
	},
})
